import api from "../api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

// Get all plans
export const getPlans = async () => {
  return api.get("/v1/api/plans");
};

// Create a new plan (full payload)
export const createPlan = async (planData) => {
  return api.post("/v1/api/plans", planData);
};

// Update — send only changed fields
export const updatePlan = async (planId, planData) => {
  return api.put(`/v1/api/plans/${planId}`, planData);
};
